<template>
  <div class="collection-case-actions-container d-inline-block">
    <dots-settings-menu
      v-bind="$attrs"
      class="collection-case-action"
      tooltip-title="Case actions"
      :delete-method="onRemoveCase"
      :delete-link="canRemoveCases"
      :delete-label="$t('cmrad.collection_remove_item')"
    >
      <template #links>
        <b-dropdown-item @click.stop.prevent="onShareCase">
          <icon-link icon-name="fa-share" :link-text="$t('cmrad.share')" />
        </b-dropdown-item>
        <b-dropdown-item @click.stop.prevent>
          <icon-link
            v-clipboard:copy="caseUrl"
            v-clipboard:success="onLinkCopied"
            v-clipboard:error="onLinkError"
            icon-name="fa-link"
            :link-text="$t('cmrad.copy_link')"
          />
        </b-dropdown-item>
        <dropdown-icon-button
          icon-name="fa-clipboard-list"
          :link-text="$t('cmrad.add_to_collection')"
          @click="onAddToCollection"
        />
      </template>
    </dots-settings-menu>
    <share-case-modal
      :id="shareCaseModalId"
      class="text-left"
      :shared-case="resource"
      :shares-count="resource.sharesCount"
    />
    <collection-add-case-modal
      :origin-case="resource"
      :value="addToCollectionModalOpen"
      @hidden="addToCollectionModalOpen = false"
    />
  </div>
</template>

<script>
  import IconLink from '@/Atoms/IconLink';
  import DropdownIconButton from '@/Atoms/DropdownIconButton';
  import ShareCaseModal from '@/Organisms/ShareCaseModal';
  import CollectionAddCaseModal from '@/Organisms/CollectionAddCaseModal';
  import toastr from 'toastr';
  import ClickOutside from 'vue-click-outside';
  import ConfirmMixin from '@/mixins/Confirm';
  import DotsSettingsMenu from '@/Molecules/DotsSettingsMenu';
  import { CaseResource } from '@/api-resources';

  export default {
    name: 'CollectionItemActions',

    components: {
      IconLink,
      ShareCaseModal,
      DotsSettingsMenu,
      CollectionAddCaseModal,
      DropdownIconButton,
    },

    mixins: [ConfirmMixin],

    props: {
      target: String,
      collectionId: Number,
      resource: CaseResource,
      value: Boolean,
      canRemoveCases: Boolean,
    },

    directives: {
      ClickOutside,
    },

    data() {
      return {
        addToCollectionModalOpen: false,
      };
    },

    computed: {
      shareCaseModalId() {
        return `share-case-modal-${this.resource.caseNumber}`;
      },

      caseUrl() {
        return this.$route('show-case', { case: this.resource.caseNumber }, true).url();
      },

      authUser() {
        return this.$page.props.auth.user.id;
      },
    },

    methods: {
      onLinkCopied() {
        toastr.success(this.$t('cmrad.copy_clipboard_success'));
      },
      onLinkError() {
        toastr.error(this.$t('cmrad.copy_clipboard_error'));
      },

      onShareCase() {
        this.$bvModal.show(this.shareCaseModalId);
      },

      onAddToCollection() {
        this.addToCollectionModalOpen = true;
      },

      async onRemoveCase() {
        const confirmed = await this.$confirm(
          this.$t('cmrad.delete_case_from_collection_confirm_text'),
          `Remove ${this.resource.title}`
        );

        if (confirmed) {
          try {
            const response = await this.$api('case_collections.remove_case', {
              case_collection: this.collectionId,
              case_radiologist: this.resource.id,
            });
            if (response) {
              toastr.success(this.$t('cmrad.remove_case_success'));
              this.$emit('removeCase', this.resource);
            } else {
              toastr.error(this.$t('cmrad.remove_case_error'));
            }
          } catch (err) {
            toastr.error('Remove case from collection failed');
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep {
    .popover-body {
      padding: 0.5rem 0;
    }
    .list-group-item {
      padding: 0.75rem 2rem;
    }
  }
</style>
